import React, { memo } from 'react';

import ErrorBoundary from '@/components/atomic/atoms/utils/error-boundary';
import IconsSprite from '@/components/atomic/molecules/data-display/icons-sprite';
import Portals from '@/components/atomic/templates/utils/portals';

const AfterEntryComponent: React.FC = () => (
	<>
		<ErrorBoundary>
			<Portals />
		</ErrorBoundary>
		<IconsSprite />
	</>
);

export default memo(AfterEntryComponent);
